"use client";
import SearchEmpty from "@/assets/icons/search-empty.png";
import { observer } from "mobx-react";
import Image from "next/image";
import { useTranslation } from "@/i18n/client";
import { useStores } from "@/models";
import { ExpiredBanner } from "@/app/s-for-addon/components/ExpiredBanner";
import { SearchBarType } from "@/app/s-for-addon/util";

export const NoResult = observer(({ k, showExpired = false, shopKeywords }: { k: string; showExpired?: boolean; shopKeywords: string; }) => {
  const { t } = useTranslation();
  const { searchForAddonStore } = useStores();
  const isExpired = searchForAddonStore.isExpired;
  const type = searchForAddonStore.type;
  const displayText = k || shopKeywords;
  return (
    <>
      {showExpired && isExpired ? (
        <ExpiredBanner text={type === String(SearchBarType.Voucher) ? t("s.couponExpired") : t("s.promoExpired")} />
      ) : (
        <div
          style={{
            color: "#C2C4CC",
            fontSize: "14px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginTop: "40px",
            justifyContent: "center",
          }}
        >
          <Image src={SearchEmpty} alt="search empty" style={{ width: "50px", height: "50px" }} />
          {t("s.noResult", { k: displayText })}
        </div>
      )}
    </>
  );
});
